import { render, staticRenderFns } from "./task_detail.vue?vue&type=template&id=639e7e3a&scoped=true"
import script from "./task_detail.vue?vue&type=script&lang=js"
export * from "./task_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e7e3a",
  null
  
)

export default component.exports